import React, { Children, FC } from 'react'
import type { WidgetMultiCardProps } from './widget-multi-card.d'
import { WidgetCard } from '@/atoms/widget-card'

export const WidgetMultiCard: FC<WidgetMultiCardProps> = ({
  children,
  childrenProps,
}) => {
  const arrayChildren = Children.toArray(children)

  return (
    <div>
      {Children.map(arrayChildren, (child, index) => {
        const isFirst = index === 0
        const isLast = index === arrayChildren.length - 1
        const position = isFirst ? 'first' : isLast ? 'last' : 'middle'
        return (
          <WidgetCard position={position} {...childrenProps[index]}>
            {child}
          </WidgetCard>
        )
      })}
    </div>
  )
}
